import React from 'react';
import styles from './index.less';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { PreviewSlideContainer } from '@com-pc/preview-slide-container';
import {
    ChangePreviewSlideScale,
    EScaleType,
} from './change-preview-slide-scale';

interface IThemePreviewListProps {
    slideWidth: number;
    slideHeight: number;
    canRevert: boolean;
    cloneUiDataService?: IUiDataService | null;
    onSelect(selectedScaleList: ISelectedScaleList): void;
    revertTheme?(): void;
}

export interface ISelectedScaleList {
    [selectedIndex: number]: boolean;
}

export interface IThemePreviewListState {
    selectedScaleList: ISelectedScaleList;
    scaleType: EScaleType;
    colNumber: number;
}

/**
 * 主题预览列表
 */
export class ThemePreviewList extends React.Component<IThemePreviewListProps, IThemePreviewListState> {
    constructor(props: IThemePreviewListProps) {
        super(props);
        this.state = {
            selectedScaleList: [],
            scaleType: EScaleType.BIG,
            colNumber: 1,
        };
    }

    render() {
        const { cloneUiDataService, slideWidth, slideHeight } = this.props;

        return <div className={styles['theme-preview-container']}>
            {/* 保留，这些功能在1期提过，新版ui暂时去掉了 */}
            {/* <div className={styles['theme-preview-title-container']}> */}
            {/*     <div className={styles['theme-preview-title-content']}>{ i18n.t('效果预览') }</div> */}
            {/*     <div className={styles['theme-preview-right-button-wrapper']}> */}
            {/*         <ChangePreviewSlideScale */}
            {/*             scaleType={this.state.scaleType} */}
            {/*             onChange={(scaleType) => { */}
            {/*                 this.setState({ */}
            {/*                     colNumber: scaleType === EScaleType.BIG ? 1 : 3, */}
            {/*                     scaleType, */}
            {/*                 }); */}
            {/*             }} */}
            {/*         /> */}
            {/*     </div> */}
            {/* </div> */}
            {/* <div className={styles['theme-preview-button-container']}> */}
            {/*     <div className={styles['theme-preview-select-all']}></div> */}
            {/*     <div */}
            {/*         onClick={this.props.revertTheme} */}
            {/*         className={ */}
            {/*             classNames({ */}
            {/*                 [styles['theme-preview-select-undo-disable']]: !this.props.canRevert, */}
            {/*                 [styles['theme-preview-select-undo']]: true, */}
            {/*             })}> */}
            {/*         <img className={classNames({ */}
            {/*             [styles['theme-preview-select-undo-icon']]: true, */}
            {/*         })} src={RESTORE_ICON} /> */}
            {/*         { i18n.t('全部恢复') } */}
            {/*     </div> */}
            {/* </div> */}
            <div className={styles['theme-preview-list-container']}>
                <PreviewSlideContainer
                    originSlideWidth={slideWidth}
                    originSlideHeight={slideHeight}
                    showBorder={true}
                    colNumber={this.state.colNumber}
                    slideList={cloneUiDataService?.presentation?.children || []}
                />
            </div>
        </div>;
    }
}
